<style lang="less" scoped>
  .my-pagination-row {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .my-pagination-col {
    padding-right: 10px;
    &:last-child {
      padding-right: 0;
    }
  }
  .pagination-btn-num {
    margin-right: 8px;
    &:last-child {
      margin-right: 0;
    }
  }
</style>

<template lang="pug">
  .my-pagination-row
    .my-pagination-col
      el-button(
      type='default',
      :disabled='!isValidButton.first',
      @click='redirect(buttonToLink.first)') {{ buttonText.first }}
    .my-pagination-col
      el-button(
        type='default',
        :disabled='!isValidButton.prev',
        @click='redirect(buttonToLink.prev)') {{ buttonText.prev }}
    .my-pagination-col
      el-button(
        v-for='(i, key) in pages'
        :type='current === i ? "primary" : "default"',
        :disabled='current === i',
        @click='redirect(i)') {{i + 1}}
    .my-pagination-col
      el-button(
        type='default',
        :disabled='!isValidButton.next',
        @click='redirect(buttonToLink.next)') {{ buttonText.next }}
    .my-pagination-col
      el-button(
        type='default',
        :disabled='!isValidButton.last',
        @click='redirect(buttonToLink.last)') {{ buttonText.last }}
</template>

<script>
export default {
  props: {
    current: { type: Number },
    url: { type: String },
    pages: { type: Array },
    queryName: { type: String },
    isValidButton: { type: Object },
    buttonText: { type: Object },
    buttonToLink: { type: Object },
  },
  data() {
    return {
      params: [],
    };
  },
  methods: {
    redirect(page) {
      const query = {};
      Object.assign(query, this.$route.query);
      query.page = page;
      const path = this.$route.path;
      this.$router.push({ path: path, query: query });
    },
  },
  mounted() {

  },
};
</script>



// WEBPACK FOOTER //
// src/components/pagination.vue